import { useState } from "react";
import { Button as ReactAriaButton } from "react-aria-components";
import clsx from "clsx";

import Caret from "../icons/caret.svg?react";

import styles from "./accordion-item.module.css";

interface AccordionItemProps {
  "data-testid"?: string;
  label: string;
  children: React.ReactNode;
  initiallyOpen?: boolean;
}

function AccordionItem({
  children,
  label,
  "data-testid": testId = "",
  initiallyOpen = false,
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(initiallyOpen);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className={styles.accordionItem} data-testid={testId}>
      <ReactAriaButton className={styles.trigger} onPress={toggleAccordion}>
        {label}
        <div className={clsx(styles.stateIcon, { [styles.closed]: !isOpen })}>
          <Caret />
        </div>
      </ReactAriaButton>

      {isOpen && <div className={clsx(styles.content)}>{children}</div>}
    </div>
  );
}

export default AccordionItem;
